import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod/v4";
import { env as runtimeEnv } from "next-runtime-env";

export const env = createEnv({
  shared: {
    NODE_ENV: z
      .enum(["development", "production", "test"])
      .default("development"),
  },
  server: {
    DB_HOST: z.string(),
    DB_PORT: z.string(),
    DB_USER: z.string(),
    DB_PASSWORD: z.string(),
    DB_NAME: z.string(),
    DB_SCHEMA: z.string(),
    STRIPE_EU_SK: z.string(),
    STRIPE_US_SK: z.string(),
    STRIPE_UK_SK: z.string(),
    STRIPE_EU_WEBHOOK_SECRET: z.string(),
    STRIPE_US_WEBHOOK_SECRET: z.string(),
    STRIPE_UK_WEBHOOK_SECRET: z.string(),
    DB_USE_SSL: z.string().optional(),
    ML_SERVICE_RETRIEVAL_URL: z.string(),
    TOLGEE_CDN_PREFIX_URL: z.string(),
    ENABLE_OTEL: z.string(),
  },
  client: {
    NEXT_PUBLIC_KEYCLOAK_REALM_URL: z.string().url(),
    NEXT_PUBLIC_KEYCLOAK_REALM_LOOKUP_URL: z.string().url().optional(),
    NEXT_PUBLIC_WS_BASE_PATH: z.string().url(),
    NEXT_PUBLIC_MIXPANEL_API_KEY: z.string(),
    NEXT_PUBLIC_API_BASE_PATH: z.string(),
    NEXT_PUBLIC_REGION: z.string().optional(),
    NEXT_PUBLIC_INTERCOM_APP_ID: z.string(),
    NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY: z.string(),
    NEXT_PUBLIC_BRAND: z.string(),
    NEXT_PUBLIC_APP_VERSION: z.string(),
    NEXT_PUBLIC_STRIPE_EU_PK: z.string(),
    NEXT_PUBLIC_STRIPE_US_PK: z.string(),
    NEXT_PUBLIC_STRIPE_UK_PK: z.string(),
    NEXT_PUBLIC_AUTH_CLIENT_ID: z.string(),
    NEXT_PUBLIC_REGION_ALLOW_CHANGE: z.boolean(),
    NEXT_PUBLIC_REGION_CURRENT: z.string().optional(),
    NEXT_PUBLIC_REGION_OTHER: z.string().optional(),
    NEXT_PUBLIC_REGION_OTHER_URL: z.string().optional(),
    NEXT_PUBLIC_TOLGEE_API_KEY: z.string(),
    NEXT_PUBLIC_TOLGEE_API_URL: z.string(),
  },
  experimental__runtimeEnv: {
    // biome-ignore lint/nursery/noProcessEnv: <explanation>
    NODE_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_KEYCLOAK_REALM_URL: runtimeEnv(
      "NEXT_PUBLIC_KEYCLOAK_REALM_URL",
    ),
    NEXT_PUBLIC_KEYCLOAK_REALM_LOOKUP_URL: runtimeEnv(
      "NEXT_PUBLIC_KEYCLOAK_REALM_LOOKUP_URL",
    ),
    NEXT_PUBLIC_WS_BASE_PATH: runtimeEnv("NEXT_PUBLIC_WS_BASE_PATH"),
    NEXT_PUBLIC_API_BASE_PATH: runtimeEnv("NEXT_PUBLIC_API_BASE_PATH"),
    NEXT_PUBLIC_MIXPANEL_API_KEY: runtimeEnv("NEXT_PUBLIC_MIXPANEL_API_KEY"),
    NEXT_PUBLIC_REGION: runtimeEnv("NEXT_PUBLIC_REGION"),
    NEXT_PUBLIC_INTERCOM_APP_ID: runtimeEnv("NEXT_PUBLIC_INTERCOM_APP_ID"),
    NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY: runtimeEnv(
      "NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY",
    ),
    // biome-ignore lint/nursery/noProcessEnv: <explanation>
    NEXT_PUBLIC_BRAND: process.env.NEXT_PUBLIC_BRAND,
    // biome-ignore lint/nursery/noProcessEnv: <explanation>
    NEXT_PUBLIC_APP_VERSION: process.env.NEXT_PUBLIC_APP_VERSION,
    NEXT_PUBLIC_STRIPE_EU_PK: runtimeEnv("NEXT_PUBLIC_STRIPE_EU_PK"),
    NEXT_PUBLIC_STRIPE_US_PK: runtimeEnv("NEXT_PUBLIC_STRIPE_US_PK"),
    NEXT_PUBLIC_STRIPE_UK_PK: runtimeEnv("NEXT_PUBLIC_STRIPE_UK_PK"),

    NEXT_PUBLIC_AUTH_CLIENT_ID:
      runtimeEnv("NEXT_PUBLIC_AUTH_CLIENT_ID") ?? "copilot-frontend",

    NEXT_PUBLIC_REGION_ALLOW_CHANGE: ["1", "true"].includes(
      runtimeEnv("NEXT_PUBLIC_REGION_ALLOW_CHANGE") ?? "",
    ),
    NEXT_PUBLIC_REGION_CURRENT: runtimeEnv("NEXT_PUBLIC_REGION_CURRENT"),
    NEXT_PUBLIC_REGION_OTHER: runtimeEnv("NEXT_PUBLIC_REGION_OTHER"),
    NEXT_PUBLIC_REGION_OTHER_URL: runtimeEnv("NEXT_PUBLIC_REGION_OTHER_URL"),
    // biome-ignore lint/nursery/noProcessEnv: <explanation>
    NEXT_PUBLIC_TOLGEE_API_KEY: process.env.NEXT_PUBLIC_TOLGEE_API_KEY,
    // biome-ignore lint/nursery/noProcessEnv: <explanation>
    NEXT_PUBLIC_TOLGEE_API_URL: process.env.NEXT_PUBLIC_TOLGEE_API_URL,
  },
  skipValidation: true,
});
